import { ReactElement } from 'react'
import { Radio, RadioGroup } from '@calabriocloud/beacon-ui'
import { useTranslation } from 'react-i18next'
import { FormSection, FormHeader } from './layout'
import { useFormikContext } from 'formik'
import { Goal } from '../../constants'
import { statusKey } from '../../constants'
export const StatusSection = (): ReactElement => {
  const { t } = useTranslation()
  const formik = useFormikContext<Goal>()
  const { status } = formik.values
  const { status: initialStatus } = formik.initialValues
  const { isDisabled } = formik.status
  const disabled = isDisabled && initialStatus === statusKey.indexOf('inactive')
  const handleChange = (value: string) => {
    formik.setFieldValue('status', Number(value))
  }
  return (
    <FormSection>
      <FormHeader title={t('goalStatusLabelv2')} />
      <RadioGroup className="flex flex-col" name='status' isRequired defaultValue="editable" onChange={handleChange} value={status.toString()}>
        <Radio data-testid='editable-option' isDisabled={disabled || initialStatus === statusKey.indexOf('active')} value={statusKey.indexOf('editable').toString()}>
          {`${t('editableColon')} ${t('editableGoalDescription')}`}
        </Radio>
        <Radio data-testid='active-option' isDisabled={disabled} value={statusKey.indexOf('active').toString()}>
          {`${t('activeColon')} ${t('activeGoalDescription')}`}
        </Radio>
        <Radio data-testid='inactive-option' isDisabled={disabled} value={statusKey.indexOf('inactive').toString()}>
          {`${t('inactiveColon')} ${t('inactiveGoalDescription')}`}
        </Radio>
      </RadioGroup>
    </FormSection>
  )
}
